/* eslint-disable no-magic-numbers */
import { randomString } from '@/utils/common-js'
import { useUserStore } from '@/store/user.store'
import { useAdChannelStore } from '@/store/adChannelCode.store'
import { ENV, getEnvironment } from '@/env'
import { navigateToExternal } from '@/utils/utils'

interface hostNameObjType {
    appName: string,
    companyName: string,
    filing:string,
    logo: string,
    appType: number,
    logoText: string
  }

// 获取域名
function useDevAPI() {
  const adChannelCode = useAdChannelStore(state => state.adChannelCode)
  // 区分环境
  // 重走表单流程
  const reloadForm = () => {
    if (getEnvironment() === 'prod') {
      return
    }
    navigateToExternal(`/getQuota${adChannelCode ? `?adChannelCode=${adChannelCode}` : ''}`)
    useUserStore.getState().logout()
    localStorage.clear()
    sessionStorage.clear()
  }

  // 随机生成手机号码
  const generateRandomPhoneNumber = () => {
    const first = '1' // 中国手机号以1开头
    const second = ['3', '4', '5', '6', '7', '8', '9'][Math.floor(Math.random() * 7)]
    const third = randomString(5, 'number')
    const phoneNumber = first + second + (`0000000${third}`).slice(-9)

    return phoneNumber
  }

  return {
    reloadForm,
    generateRandomPhoneNumber,
  }
}


export default useDevAPI